export default {
  clientAttachments: [],
  clientAttachment: undefined,
};
